// A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review.

// --- Section column lists ---

// Section 1: Program Overview
export const section1Box1Cols = [
  "program_name_s",
  "geographic_coverage",
  "start_date",
  "risk_adjustment_methodology_for_capitation_rates_and_year_implemented",
];

export const section1Box2Cols = [
  "number_of_participating_plans",
  "number_of_parent_companies",
  "profit_status_of_parent_companies_number_for_profit_number_non_profit",
];

// Section 2: Enrollment & Population
export const section2Box1Cols = [
  "total_medicaid_managed_care_enrollment",
  "share_of_total_medicaid_enrollment",
];

export const section2Box2Cols = [
  "percentage_of_medicaid_managed_care_enrollees_with_type_2_diabetes_diagnosis",
];

export const section2Box3Cols = [
  "percentage_using_insulin",
  "percentage_using_glp_1_receptor_agonists",
  "percentage_using_sglt2_inhiitors",
];

// Section 3: Covered Benefits (boolean checklist)
export const section3Box1Cols = [
  "primary_care_services",
  "prescription_drugs",
  "vision",
  "dental",
  "podiatry",
  "imaging_services",
  "lab_services",
];

export const section3Box2Cols = [
  "continuous_glucose_monitoring_cgm_for_type_2_diabetes",
  "diabetes_self_management_education_and_support_dsmes",
  "diabetes_prevention_program",
  "type_2_diabetes_screening_post_pregnancy",
];

export const section3Box3Cols = [
  "case_management_care_coordination",
  "home_health_care",
  "durable_medical_equipment",
];

export const section3Box4Cols = [
  "nutrition_supports_provided_via_section_1115_waiver",
  "nutrition_supports_as_an_in_lieu_of_service",
  "nutrition_supports_provided_as_value_added_service_vas",
];

// Section 4: Quality Measures (boolean checklist)
export const section4Box1Cols = [
  "hemoglobin_a1c_hb_a1c_control_for_patients_with_diabetes_glycemic_control_hedis_cms_adult_core_set",
  "eye_exam_for_patients_with_diabetes_preventive_care_hedis_cms_adult_core_set",
  "kidney_health_evaluation_for_patients_with_diabetes_preventive_care_hedis_cms_adult_core_set",
  "blood_pressure_control_for_patients_with_diabetes_cardiovascular_risk_hedis",
  "statin_therapy_for_patients_with_diabetes_statin_therapy_hedis",
  "diabetes_screening_for_people_with_schizophrenia_or_bipolar_disorder_using_antipsychotic_medications_high_risk_populations_hedis",
  "diabetes_monitoring_for_people_with_diabetes_and_schizophrenia_high_risk_populations_hedis",
  "diabetes_short_term_complications_admissions_rate_utilization_ahrq_pqi",
];

export const section4Box2Cols = [
  "medicaid_agency_uses_one_or_more_payment_strategies_to_incentivize_mco_performance_on_chronic_condition_related_quality_measures",
];

// Section 5: Beyond Medicaid programs
// Each entry groups the _name and _description columns for one program slot.
export const section5ProgramCols = [
  { name: "program_number_1_name", description: "program_number_1_description" },
  { name: "program_number_2_name", description: "program_number_2_description" },
  { name: "program_number_3_name", description: "program_number_3_description" },
];
